// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { play } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-play': IconPlay;
    }
}

/**
 * The icon component for the 'play' icon
 */
export class IconPlay extends IconSvg {
    public constructor() {
        super(play);
    }
}

registerIconSvg('icon-play', IconPlay);
export const iconPlayTag = 'nimble-icon-play';
